export default "__VITE_ASSET__Cr586JPu__"